/* eslint-disable import/prefer-default-export */
import * as home from './home';
import * as homeArticles from './home-articles';
import * as user from './user';
import * as matches from './matches';
import * as channels from './channels';
import * as videoDetail from './video-detail';
import * as vod from './vod';
import * as banner from './banner';
import * as seriesDetail from './series-detail';
import * as programmeGuides from './programme-guides';
import * as recommendedVideos from './recommended-videos';
import * as vuid from './vuid';
import * as articlesDetail from './articles-detail';
import * as recommendedArticles from './recommended-articles';
import * as relatedArticles from './related-articles';
import * as qrcode from './qrcode';
import * as newArticles from './new-articles';

const SET_RUNTIME_VARIABLE = 'SET_RUNTIME_VARIABLE';
const SET_NOTIF_STATUS = 'SET_NOTIF_STATUS';

export default {
  SET_RUNTIME_VARIABLE,
  ...home,
  ...user,
  ...videoDetail,
  ...matches,
  ...channels,
  ...vod,
  ...banner,
  ...seriesDetail,
  ...recommendedVideos,
  ...programmeGuides,
  ...vuid,
  ...articlesDetail,
  ...recommendedArticles,
  ...relatedArticles,
  ...qrcode,
  ...homeArticles,
  ...newArticles,
  SET_NOTIF_STATUS
};
